module.exports = __webpack_public_path__ + "img/popupbanner-location.1b61977b.png";